// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { autocompleteClasses } from '@mui/material/Autocomplete';
import { chipClasses } from '@mui/material/Chip';
import { svgIconClasses } from '@mui/material/SvgIcon';
import React from 'react';
import { rem } from '../../tokens/conversions';
import { borderRadius } from '../../tokens/spacing';
import { CaratDownIcon } from '../icons';
import { autocompleteColors } from './autocompleteColors';
export var Autocomplete = function(mode) {
    var c = autocompleteColors(mode);
    var _obj, _obj1;
    var override = {
        MuiAutocomplete: {
            styleOverrides: {
                root: (_obj = {}, _define_property(_obj, "& .".concat(autocompleteClasses.inputRoot), _define_property({
                    padding: "".concat(rem(8), " ").concat(rem(12)),
                    // OutlinedInput fixes its height; multiple-mode tags wrap onto new
                    // rows, so the input must grow instead of letting them overflow.
                    height: 'auto',
                    minHeight: rem(36),
                    gap: rem(8)
                }, "& .".concat(autocompleteClasses.input), {
                    padding: 0,
                    minWidth: rem(30)
                })), _define_property(_obj, "& .".concat(autocompleteClasses.inputRoot, ":has(.").concat(autocompleteClasses.tag, ")"), {
                    padding: "".concat(rem(4), " ").concat(rem(8))
                }), _obj),
                popupIndicator: _define_property({
                    margin: 0,
                    padding: 0
                }, "& .".concat(svgIconClasses.root), {
                    width: rem(18),
                    height: rem(18),
                    color: c.dropdownIcon
                }),
                clearIndicator: _define_property({
                    margin: 0,
                    padding: 0
                }, "& .".concat(svgIconClasses.root), {
                    width: rem(18),
                    height: rem(18),
                    color: c.clearIndicator
                }),
                paper: {
                    backgroundColor: c.paperBackground,
                    borderRadius: rem(borderRadius.default),
                    boxShadow: '0px 10px 30px 0px rgba(0, 0, 0, 0.15)'
                },
                listbox: _define_property({
                    padding: "".concat(rem(16), " ").concat(rem(12)),
                    '& > *:not(:last-child)': {
                        marginBottom: rem(8)
                    }
                }, "& .".concat(autocompleteClasses.option), (_obj1 = {
                    color: c.option.text,
                    padding: "".concat(rem(8), " ").concat(rem(12)),
                    borderRadius: rem(borderRadius.default),
                    minHeight: 'auto',
                    fontSize: rem(14),
                    fontWeight: 500,
                    lineHeight: rem(18)
                }, _define_property(_obj1, "&.".concat(autocompleteClasses.focused), {
                    backgroundColor: c.option.hoverBackground
                }), _define_property(_obj1, '&[aria-selected="true"]', {
                    backgroundColor: c.option.selectedBackground
                }), _define_property(_obj1, '&[aria-selected="true"].'.concat(autocompleteClasses.focused), {
                    backgroundColor: c.option.selectedHoverBackground
                }), _obj1)),
                tag: _define_property({
                    margin: 0
                }, "&.".concat(chipClasses.root), {
                    maxWidth: 'calc(100% - 6px)'
                }),
                // MUI centers this slot via top: 50% + translate(0, -50%); overriding top
                // without transform shifts the icons up by half their height.
                endAdornment: {
                    right: rem(12),
                    display: 'flex',
                    alignItems: 'center',
                    gap: rem(8)
                },
                // Figma: body1 typography style
                noOptions: {
                    color: c.noOptions,
                    fontSize: rem(14),
                    fontWeight: 400,
                    lineHeight: rem(18),
                    padding: rem(16)
                }
            },
            defaultProps: {
                popupIcon: /*#__PURE__*/ React.createElement(CaratDownIcon, null),
                slotProps: {
                    paper: {
                        elevation: 0
                    }
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Autocomplete.js.map